import { getExperiment } from '@eventbrite/statsig';
import {
    DisplayAdFromRecentViewsExperiment,
    IncreaseAdsInHomepageExperiment,
} from '../../../../types';

export function hasIncreasedAds() {
    const experiment = getExperiment(
        IncreaseAdsInHomepageExperiment.name,
        IncreaseAdsInHomepageExperiment.paramName,
        IncreaseAdsInHomepageExperiment.values.control,
    );

    return experiment === IncreaseAdsInHomepageExperiment.values.moreAds;
}

export function hasNewPersonalizedBucket() {
    const experiment = getExperiment(
        DisplayAdFromRecentViewsExperiment.name,
        DisplayAdFromRecentViewsExperiment.paramName,
        DisplayAdFromRecentViewsExperiment.values.control,
    );

    return experiment === DisplayAdFromRecentViewsExperiment.values.recentViews;
}

export const INCREASED_REGULAR_TAB_AD_SLOTS = [1, 6, 9, 10];
